import React, { useEffect, useState } from 'react';
import { makeGetRequest } from '../services/httpHelper';
import styled from 'styled-components';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { IMAGE_BASE_URL } from '../constants/paths';


const Section = styled.section`
  padding: 80px 0;
  background-color: #f8f9fa;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 40px;
  font-weight: bold;
  color: #333;
`;

const StyledCard = styled(Card)`
  border: none;
  height: 100%;
  transition: transform 0.3s ease-in-out;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-5px);
  }

  .card-img-top {
    height: 200px;
    object-fit: cover;
  }

  .card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

const EventsSection = () => {
  const [event, setEvent] = useState(null);
  const [events, setEvents] = useState([]);
  
  
  const church = JSON.parse(localStorage.getItem('church')) || {};



  useEffect(() => {
    // Fetch events from the backend when the component mounts
    async function fetchEvents() {
      try {
        const response = await makeGetRequest(`/church-events/${church.id}`); // Adjust the API 
         if (Array.isArray(response.data)) {
          setEvents(response.data);
        } else {
          console.warn('Expected an array, but got:', response.data);
        }
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    }

    fetchEvents();
  }, []);

  if (!events?.length) return null;

  return (
    <Section id="events">
      <Container>
        <SectionTitle>Upcoming Events</SectionTitle>
        <Row>
          {events.slice(0, 3).map((event, index) => (
            <Col md={4} sm={12} key={index} className="mb-4">
              <StyledCard>
             
                 <Card.Img variant="top" src={`${IMAGE_BASE_URL}${event.attachment}`||'https://via.placeholder.com/300x200'} crossorigin="anonymous"/> 
             
              
                <Card.Body>
                  <Card.Title>{event.event_title}</Card.Title>
                  <Card.Text>
                    <strong>Date:</strong>{' '}
                    {new Date(event.start_date).toLocaleDateString()} <br />
                    <strong>Time:</strong> {event.start_date} <br />
                    <strong>Location:</strong> {event.location}
                  </Card.Text>
                  <Button
                    variant="primary"
                    href={event.link || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn More
                  </Button>
                </Card.Body>
              </StyledCard>
            </Col>
          ))}
        </Row>
      </Container>
    </Section>
  );
};

export default EventsSection;
